import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import type AppState from 'src/types/appState';

import translations from './.vocab';

export const ProductFeatureBadge: FunctionComponent = () => {
  const { t } = useTranslations(translations);
  const { productDisplayName } = useSelector((state: AppState) => ({
    productDisplayName: state.session.productDisplayName,
  }));

  return productDisplayName ? (
    <Badge tone="promote" data={{ testid: 'product-feature-badge' }}>
      {t('product-feature-badge-label', { productDisplayName })}
    </Badge>
  ) : null;
};
